import { Box, Typography, useTheme } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { DeliverySummary } from '../../../../app/services/api/generated';

interface DeliveriesHeadlineProps {
  deliveriesThisMonth: DeliverySummary[];
  deliveriesLastMonth: DeliverySummary[];
}

const DeliveriesHeadline = ({ deliveriesThisMonth, deliveriesLastMonth }: DeliveriesHeadlineProps) => {
  const theme = useTheme();

  const currentMonthDeliveries = deliveriesThisMonth.length;
  const previousMonthDeliveries = deliveriesLastMonth.length;
  const change = currentMonthDeliveries - previousMonthDeliveries;
  const percentChange = previousMonthDeliveries === 0 ? 0 :
    (change / previousMonthDeliveries) * 100;
  const isPositive = change >= 0;

  return (
    <Box
      sx={{
        minWidth: '150px', textAlign: 'center', padding: '16px',
      }}>
      <Typography color="text.secondary"
        gutterBottom>
        Deliveries
      </Typography>
      <Typography component="h3"
        sx={{ fontWeight: 900, color: 'primary.main', my: 1 }}>
        {currentMonthDeliveries}
      </Typography>
      <Box display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}>
        {isPositive ? (
          <ArrowUpwardIcon color="success"
            fontSize="small" />
        ) : (
          <ArrowDownwardIcon color="error"
            fontSize="small" />
        )}
        <Typography component="div"
          color={isPositive ? 'success.main' : 'error.main'}
          sx={{ ml: 0.5 }}>
          {isPositive ? '+' : ''}{percentChange.toFixed(1)}%
        </Typography>
      </Box>
      <Typography component="div"
        color="text.secondary"
        sx={{ ml: 0.5 }}>
        vs last month
      </Typography>
    </Box >
  );
};

export default DeliveriesHeadline;
